import React, { useState } from 'react';
type PlanId = 'basico' | 'completo';
const plans: {
  id: PlanId;
  badge?: string;
  icon: string;
  title: string;
  subtitle: string;
  ideal: string;
  oldPrice: string;
  price: string;
  highlight?: boolean;
}[] = [{
  id: 'basico',
  icon: '📕',
  title: 'PACK ESENCIAL',
  subtitle: 'Tomo I + Tomo II + 3 Bonos',
  ideal: 'Ideal para: empezar con la base del control',
  oldPrice: '$39.999',
  price: '$19.999 ARS'
}, {
  id: 'completo',
  badge: '⭐ MÁS ELEGIDO',
  icon: '🏆',
  title: 'PACK COMPLETO + PLACER SAGRADO',
  subtitle: 'Tomo I + Tomo II + 3 Bonos + El Mapa del Placer Sagrado + 2 Bonos extra',
  ideal: 'Ideal para: dominio total del sistema',
  oldPrice: '$63.499',
  price: '$29.999 ARS',
  highlight: true
}];
export function PricingCTA() {
  const [selected, setSelected] = useState<PlanId>('completo');
  return <section className="pt-[28px] px-5 pb-[40px] text-center bg-gradient-to-b from-[#0a0a0a] via-[#120000] to-[#0a0a0a]" id="comprar" data-id="element-126">
      <div className="max-w-[680px] mx-auto px-2" data-id="element-127">
        <h2 className="font-montserrat font-black text-[clamp(1.5rem,4vw,2.2rem)] text-brand-white uppercase mb-2 leading-[1.15]" data-id="element-128">
          ELEGÍ TU <span className="text-brand-red" data-id="element-129">SISTEMA</span>
        </h2>
        <div className="w-[60px] h-[3px] bg-brand-red mx-auto mt-[10px] mb-[22px] rounded-[2px]" data-id="element-130"></div>

        <div className="flex flex-col gap-3" data-id="element-131">
          {plans.map(plan => {
          const isSelected = selected === plan.id;
          return <button type="button" key={plan.id} onClick={() => setSelected(plan.id)} aria-pressed={isSelected} className={`relative text-left w-full rounded-[12px] p-[14px_14px] transition-all duration-300 border-2 ${isSelected ? 'border-brand-red bg-brand-black-card shadow-[0_0_40px_rgba(204,0,0,0.3)]' : 'border-[#222] bg-brand-black-card hover:border-[#3a3a3a]'}`} data-id="element-132">
                {plan.badge && <span className="absolute -top-2.5 right-3 bg-brand-gold text-black font-montserrat text-[0.6rem] font-extrabold tracking-[1.5px] uppercase py-0.5 px-2.5 rounded-full shadow-[0_4px_15px_rgba(201,168,76,0.4)]" data-id="element-133">
                    {plan.badge}
                  </span>}

                <div className="flex items-center gap-3" data-id="element-134">
                  {/* Radio */}
                  <div className={`flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? 'border-brand-red' : 'border-[#444]'}`} data-id="element-135">
                    {isSelected && <span className="w-2.5 h-2.5 rounded-full bg-brand-red block" data-id="element-136"></span>}
                  </div>

                  {/* Icon */}
                  <div className="flex-shrink-0 text-xl leading-none" data-id="element-137">
                    {plan.icon}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-138">
                    <h3 className="font-montserrat font-black text-brand-white uppercase tracking-[0.3px] text-[0.82rem] leading-[1.15] mb-0.5" data-id="element-139">
                      {plan.title}
                    </h3>
                    <p className="font-opensans text-[0.72rem] text-brand-gray-text leading-[1.3] mb-0.5" data-id="element-140">
                      {plan.subtitle}
                    </p>
                    <p className="font-montserrat text-[0.68rem] font-bold text-brand-gold leading-[1.25]" data-id="element-141">
                      {plan.ideal}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="flex-shrink-0 text-right" data-id="element-142">
                    <div className="font-montserrat text-[0.7rem] text-[#3a3a3a] line-through leading-tight" data-id="element-143">
                      {plan.oldPrice}
                    </div>
                    <div className={`font-montserrat font-black text-[0.95rem] sm:text-[1.1rem] leading-tight whitespace-nowrap ${plan.highlight ? 'text-brand-red' : 'text-brand-white'}`} data-id="element-144">
                      {plan.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        <a href="#" className="mt-5 block w-full bg-gradient-to-br from-brand-red to-brand-red-dark text-white font-montserrat font-black text-[clamp(0.85rem,2.5vw,1.05rem)] uppercase tracking-[1.2px] py-3.5 px-5 rounded-lg cursor-pointer transition-all duration-300 shadow-[0_8px_30px_rgba(204,0,0,0.45)] relative overflow-hidden hover:-translate-y-[3px] hover:shadow-[0_14px_45px_rgba(204,0,0,0.65)] before:content-[''] before:absolute before:top-0 before:-left-full before:w-full before:h-full before:bg-gradient-to-r before:from-transparent before:via-[rgba(255,255,255,0.12)] before:to-transparent before:transition-[left] before:duration-500 hover:before:left-full" data-id="element-145">
          → QUIERO EL{' '}
          {selected === 'completo' ? 'PACK COMPLETO' : 'PACK ESENCIAL'}
        </a>

        <div className="flex justify-center gap-x-4 gap-y-1.5 mt-3 flex-wrap" data-id="element-146">
          <div className="text-[0.78rem] text-[#666] font-montserrat flex items-center gap-[5px]" data-id="element-147">
            🔒 Pago seguro
          </div>
          <div className="text-[0.78rem] text-[#666] font-montserrat flex items-center gap-[5px]" data-id="element-148">
            📲 Acceso inmediato
          </div>
          <div className="text-[0.78rem] text-[#666] font-montserrat flex items-center gap-[5px]" data-id="element-149">
            🛡️ Garantía 30 días
          </div>
          <div className="text-[0.78rem] text-[#666] font-montserrat flex items-center gap-[5px]" data-id="element-150">
            📱 Funciona en celular
          </div>
        </div>
      </div>
    </section>;
}